import { Typography } from "antd";
import { GiProfit } from "react-icons/gi";
import { AiOutlineApi } from "react-icons/ai";
import { BiTransferAlt } from "react-icons/bi";
import { RiFileList3Line } from "react-icons/ri";
import { HiOutlineCalculator } from "react-icons/hi";
import { isMobile } from "../../utils";

export const itensExterior = [
  {
    id: "darf",
    premium: true,
    showToBasic: false,
    link: "/velotax/exterior-historic",
    content: <Typography>Calculadora de DARF</Typography>,
    description: <Typography style={{ fontWeight: "500" }}>Cálculo de IR e emissão de DARF</Typography>,
    icon: (
      <HiOutlineCalculator
        className="no-fill"
        color="var(--ant-primary-color)"
      />
    ),
  },
  // {
  //   premium: true,
  //   id: "anual-report",
  //   link: "/velotax/exterior-report",
  //   content: <Typography>Informe de rendimentos (2022)</Typography>,
  //   description: <Typography>Relatório para declaração do IRPF</Typography>,
  //   icon: (
  //     <RiFileList3Line className="no-fill" color="var(--ant-primary-color)" />
  //   ),
  // },
  {
    id: "report",
    premium: true,
    basic: true,
    showToBasic: true,
    link: "/velotax/exterior-report",
    content: (
      <Typography>
        {/* Relatórios {!isMobile() && "(padrão Receita Federal)"} */}
        Informe de rendimentos
      </Typography>
    ),
    description: (
      <Typography style={{ fontWeight: "500" }}>Relatórios auxiliares para declaração de IR</Typography>
    ),
    icon: (
      <RiFileList3Line className="no-fill" color="var(--ant-primary-color)" />
    ),
  },
  // {
  //   id: "dividendos",
  //   premium: true,
  //   link: "/velotax/exterior-dividendos",
  //   content: <Typography>Dividendos</Typography>,
  //   icon: <GiProfit className="no-fill" color="var(--ant-primary-color)" />,
  //   description: <Typography>Gestão dos dividendos recebidos</Typography>,
  // },
  {
    id: "insert-manual",
    premium: false,
    link: "/velotax/transferencia-custodia",
    content: <Typography>Transferência de custódia</Typography>,
    icon: (
      <BiTransferAlt className="no-fill" color="var(--ant-primary-color)" />
    ),
    // description: <Typography>Gestão de transferências de custódia</Typography>,
  },
  // {
  //   id: "integration",
  //   link: "/velotax/exterior-integration",
  //   content: <Typography>Integração com XP</Typography>,
  //   icon: <AiOutlineApi className="no-fill" color="var(--ant-primary-color)" />,
  // },
];
